/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-unresolved */
import { memo, ReactNode } from "react";
import TableCell from "@mui/material/TableCell";
import Tooltip from "@mui/material/Tooltip";
import { OPTIONS } from "src/helpers/Dashboard/resources";
import HighlightText from "src/shared/HighlightText";
import Resources from "../../../../config/Resources";

interface Props {
  label: string;
  containsIcon?: Boolean;
  className?: string;
  labelClassName?: string;
  children?: ReactNode;
  onClick?: () => void;
  rowKey?: string;
}

function GenericTableCell({
  label,
  containsIcon,
  className,
  labelClassName,
  children,
  onClick,
  rowKey
}: Props) {
  const slicedLabel = (value: string) => {
    const slicedValue = value.slice(0, 14);
    return value.length > 14 ? `${slicedValue}...` : value;
  };
  return (
    <TableCell
      onClick={onClick}
      classes={{ root: `!cursor-pointer !px-1.5 !leading-4 ${className}` }}
    >
      <Tooltip
        title={
          [
            "lifeinsurername",
            "nationality",
            "sparkdecision",
            "applicationno",
            "clcapplicationno"
          ].includes(rowKey || "") &&
          slicedLabel(label).includes("...") &&
          label
        }
        placement="top"
        classes={{ tooltipPlacementTop: "!m-0.5 !font-montserrat" }}
        PopperProps={{
          className: "!z-0"
        }}
      >
        <div>
          <span
            role="presentation"
            className={`text-xs leading-3.75 -tracking-0.01 min-w-full ${labelClassName}`}
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {children?.toString().includes("object") ? (
              children
            ) : ["lifeinsurername", "nationality", "sparkdecision", "applicationno"].includes(
                rowKey || ""
              ) ? (
              ["lifeinsurername"].includes(rowKey || "") ? (
                <HighlightText text={slicedLabel(label)} />
              ) : (
                slicedLabel(label)
              )
            ) : (
              <>
                {OPTIONS?.searchToBeAppliedOn?.includes(rowKey) ? (
                  <HighlightText text={label} />
                ) : (
                  label
                )}
              </>
            )}
          </span>
          {containsIcon && (
            <img
              className="inline h-2.5 -ml-0.5"
              src={Resources.images.Dashboard.sortIcon}
              alt="sort"
              height={25}
              width={25}
            />
          )}
        </div>
      </Tooltip>
    </TableCell>
  );
}

GenericTableCell.defaultProps = {
  containsIcon: false,
  labelClassName: "",
  className: "",
  children: "",
  onClick: () => {},
  rowKey: ""
};

export default memo(GenericTableCell);
